module.exports = __webpack_public_path__ + "1b1a3a296749975f7b02443b814f3bd2.svg";